export default "__VITE_ASSET__CrR9dBRj__"